export default __webpack_public_path__ + "static/media/informationIcon.2ec1135a.svg";